import { Button } from 'antd';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  id: number;
}

const DetailButton = ({ id }: Props): ReactElement => {
  const navigate = useNavigate();
  return (
    <Button
      size='small'
      onClick={() => {
        void navigate(`/customers/${String(id)}`);
      }}
    >
      詳細
    </Button>
  );
};

export default DetailButton;
